module.exports = __webpack_public_path__ + "img/detail-btn-hen.a68ea096.png";